function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter0_f_52518_48240)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M600 400C600 373.736 594.827 347.728 584.776 323.463C574.725 299.198 559.993 277.15 541.421 258.579C522.85 240.007 500.802 225.275 476.537 215.224C452.272 205.173 426.264 200 400 200C373.736 200 347.728 205.173 323.463 215.224C299.198 225.275 277.15 240.007 258.579 258.579C240.007 277.15 225.275 299.198 215.224 323.463C205.173 347.728 200 373.736 200 400L600 400Z",
  fill: "url(#paint0_linear_52518_48240)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_52518_48240",
  x: 0,
  y: 0,
  width: 800,
  height: 600,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 100,
  result: "effect1_foregroundBlur_52518_48240"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_52518_48240",
  x1: 600,
  y1: 300,
  x2: 200,
  y2: 300,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#007AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF",
  stopOpacity: 0
})));

function SvgGlowLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowLight);
export default __webpack_public_path__ + "static/media/GlowLight.96edac30e7f9b4c5a3b55542bb144f8f.svg";
export { ForwardRef as ReactComponent };